import Socials from "./socials";

export default function Dropdown () {
    return (
        <div className="dropdown">
            <Socials />
        </div>
    )
}